import React from 'react'

export default function Tags() {
  return (
    <>
      <h1>Tags</h1>
      <p><span className='tag-grey bold'>.tag</span> class or html tag: <code> &lt;button"&gt;</code> will activate the styling for a tag </p>
      <p>There are two types of buttons: Default and Outline and you can change the color styling for the tag by changing the tag class instead of adding to the classes</p>
    
      <h2 className='mb-0'>Default Tags:</h2>
      <h3>Code :</h3>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
            &lt;span class="tag"&gt;tag&lt;/span&gt;<br/>
            &lt;span class="tag-dark"&gt;tag&lt;/span&gt;<br/>
            &lt;span class="tag-blue"&gt;tag&lt;/span&gt;<br/>
            &lt;span class="tag-green"&gt;tag&lt;/span&gt;<br/>
            &lt;span class="tag-red"&gt;tag&lt;/span&gt;<br/>
            &lt;span class="tag-grey"&gt;tag&lt;/span&gt;<br/>
            &lt;span class="tag-dgrey"&gt;tag&lt;/span&gt;<br/>
          </p>
      </div>

      <h3>Result:</h3>
      <div className='border-grey p-1 border-curve flex-align-xy'>
        <span className="tag">tag</span> &nbsp;
        <span className="tag-dark">tag</span> &nbsp;
        <span className="tag-blue">tag</span> &nbsp;
        <span className="tag-green">tag</span> &nbsp;
        <span className="tag-red">tag</span> &nbsp;
        <span className="tag-grey">tag</span> &nbsp;
        <span className="tag-dgrey">tag</span>
      </div>

      <h2 className='mt-4'>Outline Tags:</h2>
      <h3>Code :</h3>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
            &lt;span class="tag-o-green"&gt;tag&lt;/span&gt;<br/>
            &lt;span class="tag-o-red"&gt;tag&lt;/span&gt;<br/>
            &lt;span class="tag-o-blue"&gt;tag&lt;/span&gt;<br/>
            &lt;span class="tag-o-dgrey"&gt;tag&lt;/span&gt;<br/>
            &lt;span class="tag-o-grey"&gt;tag&lt;/span&gt;<br/>
            &lt;span class="tag-o-dark"&gt;tag&lt;/span&gt;<br/>
          </p>
      </div>

      <h3>Result:</h3>
      <div className='border-grey p-1 border-curve flex-align-xy'>
        <span className="tag-o-green">tag</span> &nbsp;
        <span className="tag-o-red">tag</span> &nbsp;
        <span className="tag-o-blue">tag</span> &nbsp;
        <span className="tag-o-dgrey">tag</span> &nbsp;
        <span className="tag-o-grey">tag</span> &nbsp;
        <span className="tag-o-dark">tag</span>
      </div>
    </>
  )
}
